import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

import { DashboardLayout } from '@components'
import {
  HandleTicketModalProvider,
  DeleteTicketNotificationProvider,
  HandleDeleteTicketModalProvider,
  ContractFiltersProvider,
  RoutesFiltersProvider,
  SupplierFiltersProvider,
} from '@contexts'
import { useGetConfigurationsData, useLogout } from '@hooks'

import { AdminMenu } from './AdminMenu'

dayjs.extend(isoWeek)

const selectOptions = [{ value: 'ticketId', label: 'Tren ID' }]

const AdminRoRouter = () => {
  const { logout } = useLogout()
  const { dataConfiguration } = useGetConfigurationsData()
  let tokenExpirationSeconds: number

  useEffect(() => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < dataConfiguration?.configurationProperties.length; i++) {
      if (dataConfiguration?.configurationProperties[i].key === 'TOKEN_EXPIRATION_SECONDS') {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        tokenExpirationSeconds = dataConfiguration?.configurationProperties[i].value
        break
      }
    }

    setTimeout(() => {
      if (tokenExpirationSeconds !== undefined) {
        logout()
      }
    }, (tokenExpirationSeconds - 1) * 1000)
  }, [dataConfiguration])

  return (
    <DeleteTicketNotificationProvider>
      <HandleTicketModalProvider>
        <HandleDeleteTicketModalProvider>
          <RoutesFiltersProvider>
            <ContractFiltersProvider>
              <SupplierFiltersProvider>
                <DashboardLayout menu={AdminMenu} searchSelectOptions={selectOptions}>
                  <Outlet />
                </DashboardLayout>
              </SupplierFiltersProvider>
            </ContractFiltersProvider>
          </RoutesFiltersProvider>
        </HandleDeleteTicketModalProvider>
      </HandleTicketModalProvider>
    </DeleteTicketNotificationProvider>
  )
}

export { AdminRoRouter }
